import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M16 8v8h-8","key":"svg-0"}]]

const IconChevronDownRight = createReactComponent('outline', 'chevron-down-right', 'ChevronDownRight', __iconNode);

export default IconChevronDownRight;